export default {
  bundleName: 'AppyHere Recruteur',
  loading: 'AppyHere…',
  loadingCandidate: 'Chargement du candidat...',
  firstName: 'AppyHere',
  lastName: 'Recruteur',
  deviceDetect: {
    header: 'Nous travaillons toujours sur AppyHere pour les navigateurs mobiles!',
    message: "Nous recommandons d'utiliser un ordinateur pour un expérience optimale.",
  },
  exitPromptMessage:
    'Toutes les modifications non enregistrées de votre formulaire seront perdues. Êtes-vous sûr(e) de vouloir quitter?',
  forbidden: {
    title:
      'Vous êtes actuellement connecté en tant que co-intervieweur. Pour accéder aux fonctionnalités de Recruiter Web, vous devrez vous déconnecter de votre session actuelle.',
    message: `Notez que vous ne pouvez pas être connecté simultanément en tant que co-intervieweur et en session régulière. Utilisez le bouton "Se déconnecter" ci-dessous pour pouvoir vous connecter avec votre compte Recruiter Web.`,
    goHome: "Aller à la page d'accueil",
    signOut: `Se déconnecter et aller à la page d'accueil`,
    goBack: 'Retour',
  },
};
